var map = {
	"./Abandoned Role.png": 19138,
	"./Absolute Equality.png": 27589,
	"./Abyssal Avenger.png": 76973,
	"./Act of God.png": 61259,
	"./Adjudicator's Doctrine.png": 42698,
	"./Adjudicator's Revelation.png": 80919,
	"./Adjudicator's Supremacy.png": 80375,
	"./Alchemic Regeneration.png": 59521,
	"./All That Glitters Are Apples.png": 18205,
	"./All-Night Party.png": 57092,
	"./Almost Alchemy.png": 35013,
	"./Always and Forever.png": 39423,
	"./Amber Arts.png": 94159,
	"./Amber Craft.png": 96487,
	"./Amber Enforcement.png": 70967,
	"./Amber Hunt.png": 4362,
	"./Amber Resonator.png": 97004,
	"./Amethyst's Grace.png": 58737,
	"./Anointed Overture.png": 46544,
	"./Apocalyptic Power II.png": 13876,
	"./Arcanist's Essence.png": 26533,
	"./Arcanist's Nature.png": 4770,
	"./Architect Battle Arts.png": 13557,
	"./Arcus Ars.png": 74280,
	"./Argent Halberd.png": 79115,
	"./Arma Ars.png": 58861,
	"./Arrow Storm.png": 17900,
	"./Aspire to Shine.png": 5676,
	"./Astral Arts II.png": 35455,
	"./Astral Blow II.png": 90453,
	"./Astral Claw II.png": 25462,
	"./Astral Echo II.png": 31148,
	"./Astral Pierce II.png": 48077,
	"./Astral Thrust II.png": 83399,
	"./Asuna]s Artifact.png": 7946,
	"./Audacity.png": 84896,
	"./Aura Divine.png": 52186,
	"./Authentic Memoirs.png": 23479,
	"./Axe Voltage II.png": 72170,
	"./Axe's Wrath.png": 71366,
	"./Azure Blade's Discipline.png": 46735,
	"./Azure Bow's Discipline.png": 28825,
	"./Azure Covenant.png": 37425,
	"./Azure Dagger's Discipline.png": 76559,
	"./Azure Gauntlet's Discipline.png": 68579,
	"./Azure Harp's Discipline.png": 72496,
	"./Azure Lance's Discipline.png": 13046,
	"./Azure Magnitude.png": 303,
	"./Azure Rifle's Discipline.png": 91583,
	"./Azure Rod's Discipline.png": 77228,
	"./Azure Scythe's Discipline.png": 56385,
	"./Azure Sword's Discipline.png": 83640,
	"./Baculum Ars.png": 72267,
	"./Balmy Healing Breeze.png": 92536,
	"./Baneful Hellbringer's Sanctity.png": 42032,
	"./Bang.png": 57150,
	"./Banquet of Joy.png": 68929,
	"./Barbarian's Essence.png": 778,
	"./Barbarian's Nature.png": 35207,
	"./Battlefield Tribulations.png": 45630,
	"./Bells of Grace.png": 71747,
	"./Big EX Might.png": 6002,
	"./Big Primal Aegis II.png": 14258,
	"./Big Primal Aegis.png": 25330,
	"./Big Primal Apotheosis.png": 20310,
	"./Big Primal Bloodshed.png": 23109,
	"./Big Primal Celere II.png": 17179,
	"./Big Primal Celere.png": 92905,
	"./Big Primal Clarity.png": 74351,
	"./Big Primal Crux.png": 17479,
	"./Big Primal Deathstrike.png": 56699,
	"./Big Primal Demolishment.png": 9310,
	"./Big Primal Dual-Edge.png": 36883,
	"./Big Primal Enmity.png": 3877,
	"./Big Primal Fandango.png": 1745,
	"./Big Primal First Dash.png": 4813,
	"./Big Primal Fourth Pursuit.png": 40793,
	"./Big Primal Garrison.png": 74928,
	"./Big Primal Glory.png": 59384,
	"./Big Primal Healing.png": 6281,
	"./Big Primal Heed.png": 89049,
	"./Big Primal Impalement.png": 14989,
	"./Big Primal Insignia.png": 83779,
	"./Big Primal Majesty II.png": 29706,
	"./Big Primal Majesty.png": 74618,
	"./Big Primal Might II.png": 2514,
	"./Big Primal Might III.png": 29369,
	"./Big Primal Might.png": 55570,
	"./Big Primal Mystery.png": 59908,
	"./Big Primal Precocity.png": 69071,
	"./Big Primal Primacy II.png": 64594,
	"./Big Primal Progression.png": 42318,
	"./Big Primal Second Insignia.png": 28711,
	"./Big Primal Sentence.png": 83052,
	"./Big Primal Stamina II.png": 39208,
	"./Big Primal Stamina.png": 98708,
	"./Big Primal Stratagem.png": 40795,
	"./Big Primal Tempering.png": 42862,
	"./Big Primal Third Spur.png": 27438,
	"./Big Primal Trium.png": 62450,
	"./Big Primal Tyranny II.png": 60504,
	"./Big Primal Tyranny.png": 97220,
	"./Big Primal Verity II.png": 42346,
	"./Big Primal Verity.png": 50170,
	"./Big-Sword Mode.png": 98049,
	"./Bitter Perseverance.png": 19835,
	"./Black Barrier.png": 27696,
	"./Black Covenant.png": 73577,
	"./Black Magnitude.png": 75863,
	"./Black Night Fever.png": 30745,
	"./Blade of Conquest.png": 78573,
	"./Blade's Wrath.png": 75056,
	"./Blazing Chain.png": 28562,
	"./Blood Red Blow.png": 45553,
	"./Blood Rose Barrier.png": 25410,
	"./Blood Rose Brier.png": 55999,
	"./Blood Rose Bud.png": 93262,
	"./Bloodsip Flash.png": 50840,
	"./Bonds of Blue.png": 79843,
	"./Bountiful Guidance.png": 3838,
	"./Bountiful Influence.png": 53603,
	"./Bountiful Protection.png": 16797,
	"./Bountiful Strike.png": 84158,
	"./Bow Voltage II.png": 27662,
	"./Bow Voltage.png": 28422,
	"./Bronze Rose Barrier.png": 99528,
	"./Bronze Rose Brier.png": 57609,
	"./Bronze Rose Bud.png": 39688,
	"./Bulwark's Apex.png": 50984,
	"./Bulwark's Nature.png": 57957,
	"./Calamitous Covenant.png": 59244,
	"./Carrot Hamburger.png": 60170,
	"./Cavalier's Apex.png": 27231,
	"./Cavalier's Nature.png": 37738,
	"./Ceaseless Striving.png": 94816,
	"./Celestial Guidance.png": 10454,
	"./Cepheid Variable.png": 17388,
	"./Chain Force.png": 15118,
	"./Chariot-Star's Wish.png": 18312,
	"./Cheirokmeta.png": 51098,
	"./Choking.png": 80221,
	"./Chthonian Bewailer's Jurisdiction.png": 90232,
	"./Chthonian Bewailer's Sanctity.png": 71958,
	"./Class-Trip Memories.png": 58601,
	"./Clawed Blaze.png": 86592,
	"./Clawed Flood.png": 56828,
	"./Climate Control.png": 33273,
	"./Cloud of Howling Twilight.png": 53492,
	"./Cobalt Arts.png": 97021,
	"./Cobalt Craft.png": 27997,
	"./Cobalt Enforcement.png": 61553,
	"./Cobalt Hunt.png": 42540,
	"./Cobalt Vitality.png": 14053,
	"./Concrio Albus.png": 82500,
	"./Concrio Corun.png": 71470,
	"./Concrio Ignis.png": 47489,
	"./Concrio Imber.png": 78002,
	"./Concrio Khelreos.png": 35212,
	"./Concrio Rubell.png": 72027,
	"./Concrio Terra.png": 55245,
	"./Concrio Ventus.png": 52098,
	"./Conjurer]s Acumen.png": 82693,
	"./Conjurer]s Erudition.png": 74473,
	"./Conjurer]s Sapience.png": 21090,
	"./Conjurer]s Source.png": 13709,
	"./Consecrated Sacrifice.png": 29412,
	"./Contentious Covenant.png": 95707,
	"./Contractor's Apex.png": 13005,
	"./Contractor's Nature.png": 23624,
	"./Conviction Arc.png": 64550,
	"./Conviction's Double Star.png": 34505,
	"./Cosmic Blade II.png": 85910,
	"./Cosmic Bow II.png": 4340,
	"./Cosmic Dagger II.png": 1824,
	"./Cosmic Gauntlet II.png": 88500,
	"./Cosmic Harp II.png": 41247,
	"./Cosmic Lance II.png": 68507,
	"./Cosmic Rifle II.png": 13626,
	"./Cosmic Rod II.png": 82505,
	"./Cosmic Scythe II.png": 30538,
	"./Cosmic Sword II.png": 33425,
	"./Covert Artistry.png": 73599,
	"./Crimsonic Liege.png": 92613,
	"./Crustaceous Crush.png": 35284,
	"./Culmination of Nightfall.png": 74321,
	"./Cursed Halberd.png": 91738,
	"./Cyclic Rebirth's Reverie.png": 56895,
	"./Cyclonic Strike.png": 7200,
	"./Dagger Voltage II.png": 83666,
	"./Dancer's Discipline.png": 59987,
	"./Dancer's Essence.png": 17943,
	"./Dancer's Nature.png": 47152,
	"./Dark Demon-Edge.png": 25941,
	"./Dark Destructo Fist.png": 56873,
	"./Dark Drain.png": 20832,
	"./Dawnfinder's Calm.png": 86837,
	"./Deathly Pincers.png": 85159,
	"./Debauchery's Sway II.png": 72510,
	"./Debauchery's Sway III.png": 83021,
	"./Defender's Vow.png": 73737,
	"./Deleterious Covenant.png": 48549,
	"./Delicate Strings.png": 78481,
	"./Delinquent Heart.png": 59309,
	"./Desert Yellow Blow.png": 13982,
	"./Despair's Quickening.png": 85772,
	"./Dexterity.png": 58640,
	"./Disease Demon.png": 12431,
	"./Do Not Lose or Else.png": 14197,
	"./Doctor's Essence.png": 30491,
	"./Doctor's Nature.png": 54764,
	"./Downfall of Ignorance.png": 24302,
	"./Drago Surge.png": 40555,
	"./Dragonstrike's Pursuit.png": 16250,
	"./Dragoon's Apex.png": 12438,
	"./Dragoon's Nature.png": 91955,
	"./Draph Animus Dominion.png": 80791,
	"./Draph Animus Parity.png": 11393,
	"./Draph Animus Utopia.png": 31582,
	"./Dreadflame's Claws.png": 32449,
	"./Dreadflame's Supremacy.png": 60740,
	"./Dreamward Gate.png": 16118,
	"./Drive Sprocket.png": 53879,
	"./Drum Master's Battery.png": 39243,
	"./Dual Blade's Essence.png": 56014,
	"./Dual Blade's Nature.png": 64979,
	"./Dualblade Flash's Bond.png": 57649,
	"./Eagle and Human's Prudence.png": 63052,
	"./Echinoderm.png": 40808,
	"./Einar.png": 80217,
	"./Electrifying Onslaught.png": 88298,
	"./Elegant Stratagem.png": 28598,
	"./Elemental Arts.png": 46457,
	"./Elemental Primal Garrison.png": 89753,
	"./Elysian Windrider's Jurisdiction.png": 40222,
	"./Elysian Windrider's Sanctity.png": 6272,
	"./Emerald Covenant.png": 72318,
	"./Emerald Magnitude.png": 40558,
	"./Emerald Rose Barrier.png": 93082,
	"./Emerald Rose Brier.png": 79479,
	"./Emerald Rose Bud.png": 84054,
	"./Emperor-Judgement's Awakening.png": 86407,
	"./Empress-Justice's Virtue.png": 66770,
	"./Empyrean Adjudicator's Jurisdiction.png": 53034,
	"./Empyrean Adjudicator's Sanctity.png": 7932,
	"./Enchantress's Barrier.png": 96097,
	"./Enlightened Monk's Apex.png": 95452,
	"./Enlightened Monk's Nature.png": 57041,
	"./Enriching Elevation.png": 96172,
	"./Erune Animus Dominion.png": 79333,
	"./Erune Animus Parity.png": 39827,
	"./Erune Animus Utopia.png": 30720,
	"./Essence of the East.png": 45223,
	"./Essence of the North.png": 96239,
	"./Essence of the South.png": 12077,
	"./Essence of the West.png": 36905,
	"./Eternal Animosity.png": 89720,
	"./Ever-Watching Eye.png": 71073,
	"./Evergreen Sovereign.png": 29165,
	"./Ewiyar's Gale.png": 80754,
	"./Exceed.png": 9754,
	"./Excess Voltage.png": 81758,
	"./Executioner's Essence.png": 61083,
	"./Executioner's Nature.png": 40620,
	"./Exorcist]s Acumen.png": 47768,
	"./Exorcist]s Equilibrium.png": 10307,
	"./Exorcist]s Erudition.png": 40570,
	"./Exorcist]s Sapience.png": 52199,
	"./Explosive Tenacity.png": 94862,
	"./Fang of the Way.png": 48737,
	"./Father]s Memento.png": 30721,
	"./Fediel's Eclipse.png": 37154,
	"./Femme Fatale.png": 40303,
	"./Feral Roar.png": 91266,
	"./Fine Wind, Clear Heart.png": 71139,
	"./Fire Barrier.png": 27031,
	"./Flame of the Godrender.png": 45785,
	"./Flames of Prosperity.png": 72180,
	"./Fluttering Slash.png": 86839,
	"./Fool-Hanged Man's Perseverance.png": 43439,
	"./Forbidden Putrefaction.png": 89083,
	"./Forbidden Training.png": 21589,
	"./Forest Dweller's Insight.png": 62802,
	"./Fortified Blade.png": 55130,
	"./Fortified Gauntlet.png": 21852,
	"./Fortified Harp.png": 95025,
	"./Fortified Staff.png": 58826,
	"./Fortuitous Wind Covenant.png": 60682,
	"./Four Orbs' Judgment.png": 28039,
	"./Foxflame's Glare.png": 70389,
	"./Foxy Seclusion.png": 60375,
	"./Freedom's Way.png": 73537,
	"./Fulgor Elatio.png": 81337,
	"./Gabriel's Blessing II.png": 81711,
	"./Gabriel's Blessing III.png": 23022,
	"./Galactic Bulge.png": 84887,
	"./Gale Green Blow.png": 61300,
	"./Galleon's Landslide.png": 75670,
	"./Game Changer.png": 8018,
	"./Gate of Wisdom.png": 83475,
	"./Gauntlet Voltage II.png": 2174,
	"./Gauntlet's Wrath.png": 89165,
	"./Geisa Ari.png": 27083,
	"./Ghost on the Battlefield.png": 42525,
	"./Gilded in Sage.png": 28210,
	"./Glacial Flight.png": 39695,
	"./Glacial Frostcage.png": 39095,
	"./Glacial Supremacy.png": 57984,
	"./Gladius Ars.png": 32847,
	"./God of Death.png": 44881,
	"./Gold Covenant.png": 94130,
	"./Gold Magnitude.png": 42914,
	"./Gold's Gleam.png": 61926,
	"./Golden Advent II.png": 24605,
	"./Golden Arts.png": 29715,
	"./Golden Athos.png": 55410,
	"./Golden Craft.png": 71467,
	"./Golden Enforcement.png": 16787,
	"./Golden Frailty.png": 5478,
	"./Golden Hunt.png": 40350,
	"./Golden Night Fever.png": 52525,
	"./Golden Spirit.png": 66174,
	"./Golden Vitality.png": 77135,
	"./Goldslime's Aegis.png": 24541,
	"./Grace of Healing II.png": 26865,
	"./Grand Epic.png": 41579,
	"./Graphite Arts.png": 60730,
	"./Graphite Convergence.png": 47777,
	"./Graphite Craft.png": 42824,
	"./Graphite Enforcement.png": 70040,
	"./Graphite Hunt.png": 38463,
	"./Great Turbine.png": 62650,
	"./Greatsnake's Lord-Sword.png": 35436,
	"./Gugalanna.png": 36530,
	"./Guiding Gospel.png": 39493,
	"./Guiding Revelation.png": 8634,
	"./Guiding Star's Splendor.png": 21890,
	"./Gun Voltage II.png": 19703,
	"./Gunslinger's Essence.png": 32906,
	"./Gunslinger's Nature.png": 70151,
	"./Harbinger of Destruction.png": 18343,
	"./Harbinger of the Dark Sunrise.png": 62305,
	"./Harbinger of the Dusk of Nightfall.png": 62089,
	"./Harp Voltage II.png": 46465,
	"./Harp of Hastened Light.png": 13710,
	"./Harvin Animus Dominion.png": 37006,
	"./Harvin Animus Parity.png": 31932,
	"./Harvin Animus Utopia.png": 27575,
	"./Heated Spearswipe.png": 68736,
	"./Heaven-Eye's Light.png": 18037,
	"./Heliacal Sovereign.png": 57053,
	"./Hell Mode.png": 96674,
	"./Henny Holidays.png": 50627,
	"./Herald of the Seraph.png": 39241,
	"./Hermit-Temperance's Accord.png": 80740,
	"./Hero's Stature.png": 49888,
	"./Hero's Testament.png": 2441,
	"./Heroic Tale.png": 47976,
	"./Hidden Aim.png": 45841,
	"./Hierophant-Sun's Blessing.png": 81096,
	"./High Priestess-Moon's Bewitching.png": 89626,
	"./Holy Knight's Apex.png": 57323,
	"./Holy Knight's Honor.png": 67167,
	"./Holy Knight's Nature.png": 47070,
	"./Holy Knight's Prowess.png": 61692,
	"./Holy Knight's Radiance.png": 77316,
	"./Horseman's Supremacy.png": 18668,
	"./Human Animus Dominion.png": 72163,
	"./Human Animus Parity.png": 1205,
	"./Human Animus Utopia.png": 86738,
	"./Hundred Fists.png": 58085,
	"./Hunger for Chaos.png": 70634,
	"./Hydor Theion.png": 78687,
	"./I'll Never Go Down.png": 49622,
	"./Ice Cage Aura.png": 44208,
	"./Ice Rose Barrier.png": 56445,
	"./Ice Rose Brier.png": 17384,
	"./Ice Rose Bud.png": 51317,
	"./Ice Sprite Magic.png": 8023,
	"./If You're Smiling, Any Day Is Okay.png": 88237,
	"./Immortal Dragonblood.png": 34710,
	"./Impavid Impetus.png": 53029,
	"./Impervious Covenant.png": 85345,
	"./Incantation Fang.png": 45294,
	"./Incursio Albus.png": 52225,
	"./Incursio Corun.png": 34995,
	"./Incursio Terra.png": 16988,
	"./Incursio Ventus.png": 48473,
	"./Indestructible Bachi.png": 54766,
	"./Indomitable Loyalty.png": 69194,
	"./Infernal's Rage.png": 3926,
	"./Insight of Elation.png": 88743,
	"./Instinctive Forecast.png": 27399,
	"./Intelligence.png": 74767,
	"./Iron's Vivification.png": 10101,
	"./It Follows.png": 59355,
	"./Jade Arts.png": 78012,
	"./Jade Craft.png": 32314,
	"./Jade Enforcement.png": 15278,
	"./Jade Hunt.png": 42733,
	"./Jade Valuables.png": 77785,
	"./Katana Voltage II.png": 97914,
	"./Kengo's Essence.png": 7364,
	"./Kengo's Nature.png": 71029,
	"./Kind Woodcutter's Apex.png": 95260,
	"./Kind Woodcutter's Nature.png": 62065,
	"./King's Apex.png": 1449,
	"./King's Nature.png": 8988,
	"./King's Prowess.png": 82658,
	"./King's Upheaval.png": 6205,
	"./Kingpin's Essence.png": 27538,
	"./Kingpin's Nature.png": 35071,
	"./Knight's Vivification.png": 16774,
	"./Kuninaga Gojo Crafted.png": 60146,
	"./Labrys Ars.png": 16135,
	"./Lancea Ars.png": 72972,
	"./Legend's Apex.png": 84071,
	"./Legend's Foray.png": 9576,
	"./Legend's Nature.png": 37842,
	"./Legend's Prowess.png": 67984,
	"./Legionnaire's Essence.png": 34333,
	"./Legionnaire's Nature.png": 362,
	"./Life's Vivification.png": 49321,
	"./Litus Mysticum.png": 50950,
	"./Locked on the Heart.png": 48072,
	"./Loki's Wit.png": 32283,
	"./Lone Wolf's Karma.png": 3414,
	"./Longstrider's Apex.png": 547,
	"./Longstrider's Nature.png": 50358,
	"./Lost Song of the Sages.png": 76160,
	"./Love Forbidden.png": 5361,
	"./Lovers-Death's Demise.png": 72985,
	"./Loyalty's Flame.png": 32797,
	"./Lu Woh's Authority.png": 13036,
	"./Luctor Ars.png": 89341,
	"./Lunatic Effect.png": 35607,
	"./Mad Alveolar.png": 92840,
	"./Magic Charge.png": 60985,
	"./Magical Activation Item.png": 82355,
	"./Magician-Tower's Calamity.png": 19229,
	"./Magna Abandon.png": 59477,
	"./Magna Aegis II.png": 66073,
	"./Magna Aegis.png": 12931,
	"./Magna Apotheosis.png": 46986,
	"./Magna Auspice II.png": 54218,
	"./Magna Betrayal.png": 15032,
	"./Magna Bloodshed III.png": 24295,
	"./Magna Celere II.png": 49570,
	"./Magna Celere.png": 88578,
	"./Magna Clarity II.png": 5162,
	"./Magna Clarity.png": 87194,
	"./Magna Devastation.png": 45576,
	"./Magna Encouragement II.png": 65723,
	"./Magna Enmity II.png": 47246,
	"./Magna Enmity III.png": 14269,
	"./Magna Enmity.png": 8166,
	"./Magna Essence.png": 10128,
	"./Magna Exalto.png": 47195,
	"./Magna Fandango III.png": 48125,
	"./Magna Fandango.png": 65606,
	"./Magna Garrison II.png": 52373,
	"./Magna Garrison.png": 10039,
	"./Magna Gauntlet.png": 9470,
	"./Magna Glory III.png": 68038,
	"./Magna Grace.png": 77366,
	"./Magna Haunt.png": 78810,
	"./Magna Healing II.png": 95756,
	"./Magna Healing III.png": 43255,
	"./Magna Heed.png": 62482,
	"./Magna Heroism II.png": 57305,
	"./Magna Insignia III.png": 62719,
	"./Magna Majesty II.png": 52334,
	"./Magna Majesty III.png": 96820,
	"./Magna Majesty IV.png": 60182,
	"./Magna Majesty.png": 49211,
	"./Magna Might II.png": 23053,
	"./Magna Might III.png": 70824,
	"./Magna Might.png": 11775,
	"./Magna Precocity II.png": 74890,
	"./Magna Primacy.png": 14499,
	"./Magna Progression II.png": 49277,
	"./Magna Progression III.png": 78904,
	"./Magna Resolve.png": 52350,
	"./Magna Restraint.png": 67934,
	"./Magna Sapience II.png": 86468,
	"./Magna Sentence.png": 30811,
	"./Magna Spearhead.png": 82223,
	"./Magna Stamina II.png": 13167,
	"./Magna Stamina III.png": 76654,
	"./Magna Stamina.png": 12037,
	"./Magna Sweep.png": 82846,
	"./Magna Tempering III.png": 28572,
	"./Magna Trituration.png": 90545,
	"./Magna Trium III.png": 32804,
	"./Magna Trium.png": 56203,
	"./Magna Truce.png": 91665,
	"./Magna Tyranny.png": 90521,
	"./Magna Verity II.png": 3443,
	"./Magna Verity.png": 17809,
	"./Make Our Dreams Come True.png": 2112,
	"./Makhaira Ars.png": 43308,
	"./Making a Killing.png": 38212,
	"./Mano a Mano.png": 81573,
	"./Master of the Arcane.png": 37436,
	"./Medium Primal Aegis.png": 72069,
	"./Medium Primal Auspice.png": 97820,
	"./Medium Primal Betrayal.png": 49638,
	"./Medium Primal Celere.png": 32672,
	"./Medium Primal Clarity.png": 71924,
	"./Medium Primal Dual-Edge.png": 80576,
	"./Medium Primal Enmity.png": 22763,
	"./Medium Primal Essence.png": 41106,
	"./Medium Primal Fandango.png": 62624,
	"./Medium Primal Garrison.png": 589,
	"./Medium Primal Glory.png": 27067,
	"./Medium Primal Grace.png": 61700,
	"./Medium Primal Haunt.png": 65936,
	"./Medium Primal Healing.png": 31522,
	"./Medium Primal Majesty.png": 14573,
	"./Medium Primal Might.png": 27757,
	"./Medium Primal Mystery.png": 40255,
	"./Medium Primal Primacy.png": 91914,
	"./Medium Primal Progression.png": 38833,
	"./Medium Primal Restraint.png": 84352,
	"./Medium Primal Roar.png": 29626,
	"./Medium Primal Sentence.png": 74545,
	"./Medium Primal Stamina.png": 90831,
	"./Medium Primal Tempering.png": 48721,
	"./Medium Primal Trium.png": 39537,
	"./Medium Primal Verity.png": 48191,
	"./Medium Primal Verve.png": 35540,
	"./Member of the Corps.png": 60315,
	"./Memories of War.png": 77242,
	"./Michael's Blessing II.png": 28670,
	"./Michael's Blessing III.png": 9005,
	"./Mifune Style, Binary Star.png": 81930,
	"./Mifune Style, Zen Impact.png": 12612,
	"./Mikill Las.png": 59620,
	"./Mist's Vivification.png": 35622,
	"./Munechika Sanjo Crafted.png": 27275,
	"./Musica Ars.png": 60820,
	"./Mutinous Flare.png": 89012,
	"./Mutiny's Frost Blade.png": 30160,
	"./Mutiny's Light Blade.png": 98722,
	"./Mutiny's Shadow Blade.png": 44852,
	"./Mutiny's Terra Blade.png": 57424,
	"./Mysteries of Mysteria.png": 7506,
	"./Mysterious ATK.png": 4970,
	"./Mysterious VIT II.png": 70651,
	"./Mysterious VIT.png": 96873,
	"./Mystic Musician's Melody.png": 86530,
	"./Nature's Protection.png": 27664,
	"./Nature's Providence.png": 79742,
	"./Nature's Truth.png": 90162,
	"./Nightbender's Essence.png": 19298,
	"./Nightbender's Nature.png": 85167,
	"./Noble's Dance.png": 99095,
	"./Noble's Defense.png": 14858,
	"./Nostalgic Summer.png": 88663,
	"./Nue's Cry.png": 94578,
	"./Nue's Omen.png": 71185,
	"./Ocean Blue Blow.png": 79634,
	"./Ocean's Vivification.png": 6331,
	"./Ogre's Retribution.png": 56406,
	"./Old-School Style.png": 84645,
	"./Omega Exalto Ardendi.png": 3613,
	"./Omega Exalto Unboostable.png": 9352,
	"./One Star-Soaring Show.png": 38937,
	"./One Sting, One Kill II.png": 79793,
	"./One-Hit Hologram.png": 2287,
	"./Ophidian Servitor.png": 30004,
	"./Optimus Exalto Aeros.png": 12636,
	"./Optimus Exalto Ardendi.png": 79749,
	"./Optimus Exalto Luminis.png": 23037,
	"./Optimus Exalto Unboostable.png": 41104,
	"./Optimus Exalto.png": 46158,
	"./Oracle's Allegiance.png": 54371,
	"./Oracle's Boon.png": 47854,
	"./Organic Smackdown.png": 40188,
	"./Overdraw.png": 84594,
	"./Paragon's Essence.png": 25514,
	"./Paragon's Nature.png": 5479,
	"./Party's Peak.png": 4689,
	"./Perforating Stake.png": 13821,
	"./Phantasmagoric Fencer.png": 93902,
	"./Phantom's Supremacy.png": 45800,
	"./Physician-Seer]s Acumen.png": 75263,
	"./Physician-Seer]s Benevolence.png": 19076,
	"./Physician-Seer]s Erudition.png": 76752,
	"./Physician-Seer]s Sapience.png": 45360,
	"./Piercing Fang.png": 27449,
	"./Pillar-Smasher's Conviction.png": 32048,
	"./Playboy Destroyer.png": 22527,
	"./Possessive Passion.png": 82767,
	"./Practice and Perfection.png": 20335,
	"./Prayer of the Phoenix.png": 61660,
	"./Prayer of the Sunrise.png": 40300,
	"./Preemptive Barrier.png": 50122,
	"./Preemptive Blade.png": 37813,
	"./Preemptive Wall.png": 54943,
	"./Primal Pugilism.png": 77141,
	"./Promenade of the Priestess.png": 23931,
	"./Protector of Verona.png": 24174,
	"./Proteus's Prophecy.png": 19966,
	"./Purity of Nature.png": 71441,
	"./Radiant Pearl Blow.png": 30177,
	"./Radiant Sovereign.png": 83953,
	"./Rainbow-Colored Light.png": 38795,
	"./Ranger Smoke.png": 84486,
	"./Raphael's Blessing II.png": 23789,
	"./Raphael's Blessing III.png": 26209,
	"./Rapidus Draph Animus.png": 37894,
	"./Rapidus Erune Animus.png": 80484,
	"./Rapidus Harvin Animus.png": 36061,
	"./Rapidus Human Animus.png": 50866,
	"./Realm Binder.png": 73553,
	"./Realm-Breaker's Animus.png": 78237,
	"./Reigning Champ's Essence.png": 58690,
	"./Reigning Champ's Nature.png": 5071,
	"./Reincarnation.png": 16245,
	"./Renew Soul.png": 86682,
	"./Reptile Slaughter.png": 678,
	"./Resilient Gale.png": 1260,
	"./Resilient Shadow.png": 19373,
	"./Resilient Shine.png": 69692,
	"./Resplendent Ruler's Sanctity.png": 66569,
	"./Resplendent Ruler]s Jurisdiction.png": 82325,
	"./Reverberating Rhythm.png": 52608,
	"./Riff on Resonance.png": 74898,
	"./Rightway Pathfinder II.png": 14304,
	"./Robar Tiempo.png": 49142,
	"./Rockslide Bullet.png": 92828,
	"./Rose's Refuge.png": 64521,
	"./Rouge Pierre Tempest.png": 3417,
	"./Royal Gift.png": 90299,
	"./Royal Purple Blow.png": 55463,
	"./Royal Wing Barrier.png": 86621,
	"./Rugged Woodcutter's Apex.png": 91772,
	"./Rugged Woodcutter's Nature.png": 50545,
	"./Safeguard.png": 10,
	"./Sage's Aura.png": 40019,
	"./Saint's Essence.png": 56687,
	"./Saint's Nature.png": 52280,
	"./Sangre Caliente.png": 56115,
	"./Sauna-Goer's Companion.png": 9866,
	"./Savage Mythology.png": 50991,
	"./Saving Grace II.png": 13312,
	"./Scales of Nightfall.png": 91137,
	"./Scales of Wrath.png": 71816,
	"./Scales of the Sunrise.png": 1420,
	"./Scandere Catena.png": 47273,
	"./Scarlet Arts.png": 52497,
	"./Scarlet Convergence.png": 41205,
	"./Scarlet Craft.png": 67820,
	"./Scarlet Enforcement.png": 82196,
	"./Scarlet Hunt.png": 6611,
	"./Scarlet Reticle.png": 6986,
	"./Scarlet Swashbuckler.png": 62648,
	"./Searing Enlightener's Sanctity.png": 39297,
	"./Self-taught Mastery.png": 40365,
	"./Sephira Legio Aquae.png": 28483,
	"./Sephira Legio Tenebris.png": 40694,
	"./Sephira Legio.png": 21438,
	"./Sephira Manus Aquae.png": 76115,
	"./Sephira Manus Terra.png": 33015,
	"./Sephira Manus.png": 86030,
	"./Sephira Maxi.png": 33675,
	"./Sephira Salire Tenebris.png": 71550,
	"./Sephira Salire Terra.png": 5516,
	"./Sephira Salire.png": 62166,
	"./Sephira Soul.png": 52078,
	"./Sephira Tek.png": 17146,
	"./Sephira Telum.png": 82995,
	"./Sephirath Brogue II.png": 83780,
	"./Sephirath Corant II.png": 6501,
	"./Sephirath Eparc II.png": 96797,
	"./Sephirath Fusame II.png": 14443,
	"./Sephirath Haton II.png": 59926,
	"./Serenity's Mead.png": 23984,
	"./Seven Gem Barrier.png": 619,
	"./Shadowhound's Essence.png": 26445,
	"./Shadowhound's Nature.png": 44343,
	"./Shady Business II.png": 94583,
	"./Shall We Duel.png": 24368,
	"./Shark Control.png": 69824,
	"./Shell of the Bereft.png": 96290,
	"./Shell-Piercing.png": 72848,
	"./Shield-Tearing Dance.png": 24243,
	"./Shining Beacon.png": 72346,
	"./Shock on Contact.png": 1239,
	"./Shoots and Leaves.png": 48229,
	"./Shredder's Essence.png": 54269,
	"./Shredder's Nature.png": 84746,
	"./Sica Ars.png": 90450,
	"./Sidearm.png": 77241,
	"./Silver's Sparkle.png": 85581,
	"./Silverslime's Aegis.png": 91146,
	"./Six Dragons' Radiance.png": 93346,
	"./Skyrule Storm.png": 17982,
	"./Slaughterous Sovereign.png": 17996,
	"./Slayer of Immortals II.png": 98765,
	"./Slaysnake's Myth II.png": 57379,
	"./Small Primal Aegis.png": 74099,
	"./Small Primal Auspice.png": 72253,
	"./Small Primal Bladeshield.png": 39467,
	"./Small Primal Celere.png": 15474,
	"./Small Primal Clarity.png": 87626,
	"./Small Primal Dual-Edge.png": 56234,
	"./Small Primal Enmity.png": 3574,
	"./Small Primal Fandango.png": 6518,
	"./Small Primal Garrison.png": 6247,
	"./Small Primal Grace.png": 73830,
	"./Small Primal Healing.png": 25008,
	"./Small Primal Majesty.png": 88363,
	"./Small Primal Might.png": 90127,
	"./Small Primal Mystery.png": 11605,
	"./Small Primal Refuge.png": 83436,
	"./Small Primal Restraint.png": 24974,
	"./Small Primal Sentence.png": 93515,
	"./Small Primal Spearhead.png": 36991,
	"./Small Primal Stamina.png": 87317,
	"./Small Primal Tempering.png": 76515,
	"./Small Primal Trium.png": 4219,
	"./Small Primal Verity.png": 49825,
	"./Smiling Is Magic.png": 87308,
	"./Solaris's Supremacy.png": 15528,
	"./Solaris]s Supremacy.png": 29590,
	"./Soul Resonance.png": 40323,
	"./Spear Voltage II.png": 98591,
	"./Speed Cast.png": 58020,
	"./Spirit of Giving.png": 16406,
	"./Spirit of the Morning Star.png": 36943,
	"./Spirit's Aegis.png": 95510,
	"./Splitting Bamboo.png": 69594,
	"./Staff Resonance.png": 922,
	"./Staff Voltage II.png": 75956,
	"./Star-Sea Sovereign's Decree.png": 91340,
	"./Sting of the Dragon Fang.png": 50268,
	"./Storm's Vivification.png": 93784,
	"./Strategist's Temperament.png": 51914,
	"./Street Fighter.png": 2808,
	"./Strike": 9444,
	"./Strike Dark.png": 27182,
	"./Strike Earth.png": 38744,
	"./Strike Fire.png": 67050,
	"./Striking Art.png": 91134,
	"./Succession of Knighthood.png": 47120,
	"./Sunlight's Stimulant.png": 36213,
	"./Sunveil's Crown.png": 93489,
	"./Sunveil's Radiance.png": 27041,
	"./Supremacy's Fist.png": 72637,
	"./Supreme Trepidation.png": 6232,
	"./Swiftblade Oath.png": 47223,
	"./Sword Princess.png": 59874,
	"./Sword Voltage II.png": 74343,
	"./Sword Voltage.png": 51757,
	"./Sword of the Saviour.png": 74526,
	"./Sword's Charge.png": 74285,
	"./Sword's Wrath.png": 17713,
	"./Swordmaster's Soul.png": 50094,
	"./Synchronized Artistry.png": 15136,
	"./Teachers' Guidance II.png": 45904,
	"./Teachers' Guidance III.png": 26163,
	"./Technical Artistry.png": 59043,
	"./Tell Ibrahim.png": 18795,
	"./Tenacious Dinosaur.png": 40144,
	"./Tetra's Essence.png": 55060,
	"./Tetra's Nature.png": 49125,
	"./The Butcher's Knife.png": 96257,
	"./The Light in the Dark.png": 36577,
	"./The Opening Draw.png": 11099,
	"./The Pulse.png": 46310,
	"./Three-Sister Rule.png": 11973,
	"./Through Tempest and Torrent.png": 5084,
	"./Thunder God's Authority.png": 14713,
	"./Thunder God's Subjugation.png": 60825,
	"./Thunderswift Bladework.png": 28964,
	"./Tidings of the New World.png": 9842,
	"./Titan's Aegis.png": 25389,
	"./Transcendent Cuteness.png": 68985,
	"./Transience of Life.png": 49551,
	"./Treasure Trick.png": 5604,
	"./Trick or Treat.png": 37518,
	"./Trick or Trick.png": 71175,
	"./Trickster.png": 2773,
	"./Triple Talon Hellion.png": 17247,
	"./True Adjudicator's Supremacy.png": 47689,
	"./True Dreadflame's Supremacy.png": 24570,
	"./True Enchantment.png": 77809,
	"./True Glacial Supremacy.png": 37594,
	"./True Horseman's Supremacy.png": 18186,
	"./True Phantom's Supremacy.png": 13042,
	"./True Solaris's Supremacy.png": 20074,
	"./Trump Card.png": 15268,
	"./Trust in Me.png": 17455,
	"./Tuna Toss.png": 33083,
	"./Twilight.png": 83706,
	"./Two-Sword Tech.png": 6516,
	"./Ultimate Wisdom's Shine.png": 24597,
	"./Unboostable Ascendancy.png": 8127,
	"./Unboostable Crux.png": 42164,
	"./Unboostable Enmity.png": 67578,
	"./Unboostable Excelsior.png": 17948,
	"./Unboostable Exertion.png": 53072,
	"./Unboostable Fortitude.png": 18726,
	"./Unboostable Initiation.png": 50134,
	"./Unboostable Marvel.png": 67089,
	"./Unboostable Might.png": 38419,
	"./Unboostable Mystery.png": 78969,
	"./Unboostable Pact.png": 56140,
	"./Unboostable Persistence.png": 18171,
	"./Unboostable Prowess.png": 40329,
	"./Unboostable Quenching.png": 87312,
	"./Unboostable Quintessence.png": 24529,
	"./Unboostable Spectacle.png": 56324,
	"./Unboostable Stamina.png": 98393,
	"./Unboostable Surge.png": 54528,
	"./Unboostable Trium.png": 24767,
	"./Unboostable Verity.png": 12605,
	"./Uncrossable Paradise.png": 96212,
	"./Undaunted Cyclone.png": 59535,
	"./Undefeated Hero.png": 48625,
	"./Undersky's Hatebonds.png": 80539,
	"./Undersky's Whispers.png": 25576,
	"./Unidentified Forbidden Oomph.png": 42796,
	"./Uriel's Blessing II.png": 38108,
	"./Uriel's Blessing III.png": 90919,
	"./Venerator's Apex.png": 2234,
	"./Venerator's Nature.png": 69583,
	"./Verdant Sovereign.png": 11648,
	"./Verglas Sovereign.png": 39642,
	"./Vermillion Covenant.png": 72687,
	"./Vermillion Magnitude.png": 64637,
	"./Vertical Maneuvering Assault.png": 53206,
	"./Vessel Phantasmic.png": 73798,
	"./Vessel's Desolation.png": 59368,
	"./Victorious Covenant.png": 28299,
	"./Vigilante's Essence.png": 26877,
	"./Vigilante's Nature.png": 28842,
	"./Virtue's Champion.png": 26726,
	"./Virtuoso's Essence.png": 15313,
	"./Virtuoso's Nature.png": 70438,
	"./Vision of the Future.png": 64665,
	"./Visitor in the Night.png": 76730,
	"./Vita Ignis.png": 29470,
	"./Vita Imber.png": 57065,
	"./Voidbroken Wing.png": 96790,
	"./Voidcast Arrow.png": 37634,
	"./Voidfeigned Crag.png": 34519,
	"./Voidforged Lance.png": 3118,
	"./Voidsung Grasp.png": 20256,
	"./Volcanic Blade.png": 70327,
	"./Vouge Hymn II.png": 77664,
	"./Wamdus's Flood.png": 61563,
	"./Wanderer's Essence.png": 72684,
	"./Wanderer's Nature.png": 16429,
	"./War God's Swing II.png": 87747,
	"./War-Beast Bond.png": 6093,
	"./Warlord's Lance.png": 17208,
	"./Warrior Monk's Apex.png": 76555,
	"./Warrior Monk's Nature.png": 87102,
	"./Warspirit's Sword Dance.png": 51113,
	"./Westerly Crescendo.png": 97819,
	"./Whispers of Death.png": 90866,
	"./White Covenant.png": 24299,
	"./White Magnitude.png": 5494,
	"./Wicked Fangs.png": 37422,
	"./Wild Wanderer.png": 87030,
	"./Wilnas's Firestorm.png": 4609,
	"./Wings of Divinity.png": 69009,
	"./With This, I'm Invincible.png": 52708,
	"./Yes, My Lord.png": 98750,
	"./Zenith Art.png": 27501,
	"./Zenith Strike.png": 9150,
	"./Zero to Hero.png": 38261,
	"./砕世毀の鬼魄.png": 92333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69564;